import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col min-h-screen" }
const _hoisted_2 = { class: "flex flex-col flex-grow bg-background" }
const _hoisted_3 = { class: "container pt-8" }
const _hoisted_4 = { class: "flex flex-row items-center justify-between" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-5 w-5 text-primary",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z",
      "clip-rule": "evenodd"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-4" }, "Back")
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "flex flex-col card-main my-8" }
const _hoisted_8 = { class: "flex flex-col" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, "Talent’s name and role", -1)
const _hoisted_10 = { class: "grid grid-cols-2 gap-4 mt-4" }
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Email", -1)
const _hoisted_13 = { class: "flex flex-col" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "Employee ID", -1)
const _hoisted_15 = { class: "flex flex-col" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "Company", -1)
const _hoisted_17 = { class: "flex flex-col" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "Role", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-300 h-px w-full my-8" }, null, -1)
const _hoisted_20 = { class: "flex flex-col" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, "Role information", -1)
const _hoisted_22 = { class: "grid grid-cols-2 gap-4 mt-4" }
const _hoisted_23 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "Job (Optional if you want to pre-load values)", -1)
const _hoisted_25 = { class: "grid grid-cols-2 gap-4 mt-4" }
const _hoisted_26 = { class: "flex flex-col" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", null, "Name", -1)
const _hoisted_28 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_29 = { class: "flex flex-col" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", null, "Department", -1)
const _hoisted_31 = { class: "flex flex-col mt-4" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", null, "Responsibilities", -1)
const _hoisted_33 = { class: "flex flex-col mt-4" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", null, "Requirements", -1)
const _hoisted_35 = { class: "flex flex-col mt-4" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", null, "Benefits", -1)
const _hoisted_37 = ["disabled", "onUpdate:modelValue"]
const _hoisted_38 = ["onUpdate:modelValue", "disabled"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("option", { value: "usd" }, "US Dollar (USD)", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("option", { value: "mxn" }, "Mexican Peso (MXN)", -1)
const _hoisted_41 = [
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = {
  key: 0,
  class: "flex flex-row items-center mt-4"
}
const _hoisted_43 = { class: "mr-4" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("option", { value: "usd" }, "US Dollar (USD)", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("option", { value: "mxn" }, "Mexican Peso (MXN)", -1)
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-300 h-px w-full my-8" }, null, -1)
const _hoisted_48 = { class: "flex flex-row items-center justify-between" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-6 w-6 text-primary",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "stroke-width": "2"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M5 10l7-7m0 0l7 7m-7-7v18"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-4" }, "Back to the top")
], -1)
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = ["disabled"]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-5 w-5 text-white",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
      "clip-rule": "evenodd"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-4" }, "Done")
], -1)
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = {
  key: 0,
  class: "flex justify-center items-center fixed inset-y-0 right-0 overflow-x-hidden overflow-y-hidden z-50 w-full"
}
const _hoisted_55 = { class: "flex relative w-1/2 h-auto" }
const _hoisted_56 = { class: "flex flex-col bg-white w-full h-auto rounded-2xl shadow p-8" }
const _hoisted_57 = { class: "flex flex-row justify-end" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6 text-gray-500",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-semibold mt-4" }, " Are you sure you want to add a new talent? ", -1)
const _hoisted_61 = { class: "flex flex-row justify-between mt-8" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { key: 1 }
const _hoisted_64 = {
  key: 0,
  class: "bg-error p-2 rounded text-white text-center mt-4"
}
const _hoisted_65 = {
  key: 1,
  class: "bg-black opacity-50 fixed inset-y-0 right-0 z-40 w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_SelectDropdown = _resolveComponent("SelectDropdown")!
  const _component_Bullets = _resolveComponent("Bullets")!
  const _component_NewCurrencyField = _resolveComponent("NewCurrencyField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/talent'))),
            class: "btn-outline-lg"
          }, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_TextField, {
                  modelValue: _ctx.email,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
                  name: "email",
                  label: "Email...",
                  typeInput: "text",
                  isError: _ctx.fieldErrors.email
                }, null, 8, ["modelValue", "isError"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_TextField, {
                  modelValue: _ctx.Empleado_ID,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.Empleado_ID) = $event)),
                  name: "Empleado_ID",
                  label: "Employee ID...",
                  typeInput: "text",
                  isError: _ctx.fieldErrors.Empleado_ID
                }, null, 8, ["modelValue", "isError"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(_component_SelectDropdown, {
                  modelValue: _ctx.company_id,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.company_id) = $event)),
                  options: _ctx.companies,
                  label: "Company...",
                  name: "company_id"
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                (_openBlock(), _createBlock(_component_SelectDropdown, {
                  modelValue: _ctx.position_id,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.position_id) = $event)),
                  name: "position_id",
                  options: _ctx.positionOptions,
                  label: "Role...",
                  key: _ctx.refreshCounterRole
                }, null, 8, ["modelValue", "options"]))
              ])
            ])
          ]),
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              (_ctx.isNew)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _hoisted_24,
                    _createVNode(_component_SelectDropdown, {
                      modelValue: _ctx.job_id,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.job_id) = $event)),
                      options: _ctx.jobs,
                      label: "Jobs",
                      name: "job_id"
                    }, null, 8, ["modelValue", "options"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createVNode(_component_TextField, {
                  disabled: !_ctx.isNew,
                  modelValue: _ctx.name,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.name) = $event)),
                  name: "name",
                  label: "Name..."
                }, null, 8, ["disabled", "modelValue"]),
                (_ctx.errorName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, " This role already exists. "))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createVNode(_component_SelectDropdown, {
                  disabled: !_ctx.isNew,
                  modelValue: _ctx.department,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.department) = $event)),
                  options: _ctx.departmentOptions,
                  name: "department",
                  label: "Department..."
                }, null, 8, ["disabled", "modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createVNode(_component_Bullets, {
                disabled: !_ctx.isNew,
                modelValue: _ctx.responsibilities,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.responsibilities) = $event)),
                name: "responsibilities",
                placeholder: "Responsibilities..."
              }, null, 8, ["disabled", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _createVNode(_component_Bullets, {
                disabled: !_ctx.isNew,
                modelValue: _ctx.requirements,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.requirements) = $event)),
                name: "requirements",
                placeholder: "Requirements..."
              }, null, 8, ["disabled", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.benefits, (benefit, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: _normalizeClass(["flex flex-row", { 'mt-4': i > 0 }])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    disabled: !_ctx.isNew,
                    "onUpdate:modelValue": ($event: any) => ((_ctx.benefits[i].name) = $event),
                    placeholder: "Name",
                    type: "text",
                    class: "bg-background rounded px-4 py-5 focus:outline-none disabled:cursor-not-allowed mr-4"
                  }, null, 8, _hoisted_37), [
                    [_vModelText, _ctx.benefits[i].name]
                  ]),
                  (_openBlock(), _createBlock(_component_NewCurrencyField, {
                    disabled: !_ctx.isNew,
                    modelValue: _ctx.benefits[i].value,
                    "onUpdate:modelValue": ($event: any) => ((_ctx.benefits[i].value) = $event),
                    name: `benefits-${i}-value`,
                    label: "Amount",
                    key: _ctx.refreshCounterChange
                  }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "name"])),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": ($event: any) => ((_ctx.benefits[i].currency) = $event),
                    disabled: !_ctx.isNew,
                    class: "bg-background py-5 px-3 rounded ml-4 disabled:cursor-not-allowed"
                  }, _hoisted_41, 8, _hoisted_38), [
                    [_vModelSelect, _ctx.benefits[i].currency]
                  ])
                ], 2))
              }), 128)),
              (_ctx.isNew && !_ctx.errorName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newBenefitName) = $event)),
                        placeholder: "New item",
                        type: "text",
                        class: "bg-background rounded px-4 py-5 focus:outline-none"
                      }, null, 512), [
                        [_vModelText, _ctx.newBenefitName]
                      ])
                    ]),
                    (_openBlock(), _createBlock(_component_NewCurrencyField, {
                      modelValue: _ctx.newBenefitAmount,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newBenefitAmount) = $event)),
                      name: "newBenefitAmount",
                      label: "Amount",
                      key: _ctx.refreshCounterV
                    }, null, 8, ["modelValue"])),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.newBenefitCurrency) = $event)),
                      class: "bg-background py-5 px-3 rounded ml-4"
                    }, _hoisted_46, 512), [
                      [_vModelSelect, _ctx.newBenefitCurrency]
                    ]),
                    _createElementVNode("button", {
                      class: "btn-filled-sm ml-4",
                      onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.addBenefit && _ctx.addBenefit(...args)))
                    }, " Add benefit ")
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _hoisted_47,
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("button", {
              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.scrollToTop && _ctx.scrollToTop(...args))),
              class: "btn-text"
            }, _hoisted_50),
            _createElementVNode("button", {
              disabled: _ctx.errorName,
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.openModal = true)),
              class: "btn-filled-lg disabled:cursor-not-allowed disabeld:opacity-50"
            }, _hoisted_53, 8, _hoisted_51)
          ])
        ])
      ])
    ]),
    (_ctx.openModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("button", {
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.openModal = false))
                }, _hoisted_59)
              ]),
              _hoisted_60,
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("button", {
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.openModal = false)),
                  class: "btn-outline-sm"
                }, " Back "),
                _createElementVNode("button", {
                  onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
                  class: _normalizeClass({
                'btn-filled-sm': !_ctx.loading,
                'btn-filled-sm-loading': _ctx.loading,
              })
                }, [
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_62, "Loading..."))
                    : (_openBlock(), _createElementBlock("span", _hoisted_63, "Continue"))
                ], 2)
              ]),
              (_ctx.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_64, " Something went wrong, please try again "))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.openModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_65))
      : _createCommentVNode("", true)
  ]))
}